export default {
  countCells: 10,
  massive: [
    {
      dataField: 'org',
      cols: 2,
      rows: 1,
      text: 'Организация',
      class: 'd-flex flex-row align-center justify-start ',
      headerStyles: `min-width: 350px;`,
      order: 1,
      variable: true,
    },
    {
      dataField: 'form42scan',
      cols: 4,
      rows: 1,
      text: `Посмотреть подписанную организацией заявку`,
      order: 2,
      class: 'd-flex flex-row align-center justify-center ',
      variable: true,
    },
    {
      dataField: 'form42Foivscan',
      cols: 4,
      rows: 1,
      text: 'Подписание формы 4.2',
      class: 'd-flex flex-row align-center justify-center ',
      order: 3,
      variable: true,
    },
  ]
}